import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type OrganizationsWithNodeEditorTemplateIdQueryVariables = Types.Exact<{
  organizationIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type OrganizationsWithNodeEditorTemplateIdQuery = { __typename: 'Query', organizations: Array<{ __typename: 'Organization', id: string, legacyId: number, nodeEditorTemplate?: { __typename: 'Template', legacyId: number, id: string } | null } | null> };

export type MaterialEditorCreateMaterialRevisionMutationVariables = Types.Exact<{
  input: Types.MutationCreateMaterialRevisionFromGraphNodeInput;
}>;


export type MaterialEditorCreateMaterialRevisionMutation = { __typename: 'Mutation', createMaterialRevisionFromGraphNode: { __typename: 'MaterialRevision', id: string, legacyId: number, number: number } };

export type MaterialEditorDataQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
  materialRevisionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type MaterialEditorDataQuery = { __typename: 'Query', materialEditorData: { __typename: 'MaterialEditorMaterial', id: string, name?: string | null, revisions: Array<{ __typename: 'MaterialEditorMaterialRevision', id: string, number: number }>, revision?: { __typename: 'MaterialEditorMaterialRevision', id: string, legacyId: number, number: number, graphNode?: any | null } | null } };

export const OrganizationsWithNodeEditorTemplateIdDocument = gql`
    query organizationsWithNodeEditorTemplateId($organizationIds: [ID!]!) {
  organizations(filter: {id: {in: $organizationIds}}) {
    id
    legacyId
    nodeEditorTemplate {
      legacyId
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationsWithNodeEditorTemplateIdGQL extends Apollo.Query<OrganizationsWithNodeEditorTemplateIdQuery, OrganizationsWithNodeEditorTemplateIdQueryVariables> {
    override document = OrganizationsWithNodeEditorTemplateIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialEditorCreateMaterialRevisionDocument = gql`
    mutation materialEditorCreateMaterialRevision($input: MutationCreateMaterialRevisionFromGraphNodeInput!) {
  createMaterialRevisionFromGraphNode(input: $input) {
    id
    legacyId
    number
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialEditorCreateMaterialRevisionGQL extends Apollo.Mutation<MaterialEditorCreateMaterialRevisionMutation, MaterialEditorCreateMaterialRevisionMutationVariables> {
    override document = MaterialEditorCreateMaterialRevisionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialEditorDataDocument = gql`
    query materialEditorData($materialId: ID!, $materialRevisionId: ID) {
  materialEditorData(materialId: $materialId) {
    id
    name
    revisions {
      id
      number
    }
    revision(revisionId: $materialRevisionId) {
      id
      legacyId
      number
      graphNode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialEditorDataGQL extends Apollo.Query<MaterialEditorDataQuery, MaterialEditorDataQueryVariables> {
    override document = MaterialEditorDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }